import { createContext } from 'react';

export const context = createContext<{
  resolvePathFromSlug: (slug: string) => string | null;
}>(undefined as any);
